import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize';
import type { ChangeEvent, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import type { DemandPartnerType } from '../../../utils/participantFunctions';
import { DealParticipantsField } from '../fields';

import { ParticipantBuyersSingleInfo } from './ParticipantBuyersSingleInfo';

export interface ParticipantBuyersSingleProps {
  fieldPrefix: string;
  getBuyerOptionLabel: (option: string) => string;
  filteredBuyersOption: string[];
  isBuyersLoading: boolean;
  buyerId: string | null;
  demandPartnerType: DemandPartnerType;
  onSingleBuyerIdChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
}

export const ParticipantBuyersSingle = ({
  fieldPrefix,
  getBuyerOptionLabel,
  filteredBuyersOption,
  onSingleBuyerIdChange,
  demandPartnerType,
  buyerId,
  isBuyersLoading,
}: ParticipantBuyersSingleProps) => {
  const { t } = useTranslation();

  return (
    <>
      <RHFAutoCompleteVirtualize
        name={`${fieldPrefix}${DealParticipantsField.BUYER_ID}`}
        textFieldProps={{
          label: t('DSP Seat IDs'),
          margin: 'dense',
          placeholder: t('[ Select DSP Seat IDs ]'),
        }}
        disableClearable
        getOptionLabel={getBuyerOptionLabel}
        options={filteredBuyersOption}
        value={isBuyersLoading ? '' : (buyerId as string)}
        onChange={onSingleBuyerIdChange as (_: SyntheticEvent, value: string) => void}
        loading={isBuyersLoading}
        data-test="deal-dsp-seat-ids"
      />
      <ParticipantBuyersSingleInfo demandPartnerType={demandPartnerType} />
    </>
  );
};
